import { useFlags } from '@mint-lib/routing-context';

export const useInfiniteScrollFF = () => {
  const ff = useFlags('@mint/arm', ['importHubInfiniteScroll']);

  return ff.importHubInfiniteScroll.enabled;
};
